import { ReactComponent as AppsIcon } from '@Icons/additional/widgets.svg';

import { BaseNameSideItem } from '../../../../../enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const childrens = [
  createItem('Employee Self Service', 'EmployeeSelfService'),
  createItem('Material Request', 'MaterialRequest'),
];

const AppsMenuItem: MenuItem = createItem(
  BaseNameSideItem.APPS,
  BaseNameSideItem.APPS,
  <AppsIcon />,
  childrens
);

export default AppsMenuItem;
